<template>
  <div id="CpapMaskSelectModal" style="width: 1350px;height:1100px;margin-left:350px;margin-top:20px;">
    <div class="modal-card" style="width: 100%;height:100%;">
      <header class="modal-card-head">
        <p class="modal-card-title" style="color: whitesmoke;">マスク選択</p>
      </header>
      <section class="modal-card-body">
        <!--検索条件 -->
        <div class="condition-area">
          <table class="conditionTable" style="width:1300px;">
            <tr style="height:50px;">
              <td colspan="4" style="padding:0px;">
                <img style="width:1300px; height:50px;" :src="require('@/assets/maskPng/maskList.png')">
              </td>
            </tr>
            <tr>
              <div class="image-box">
                <img style="width: 140px; padding-left: 10px;" :src="require('@/assets/maskPng/list-dreamWearNasalMask.png')" @click="setMaskType('ﾄﾞﾘｰﾑｳｪｱﾈｰｻﾞﾙﾏｽｸ','dreamWearNasalMask')">
                <img style="width: 140px; padding-left: 10px;" :src="require('@/assets/maskPng/list-wispPediatricNasalMask.png')" @click="setMaskType('ｳｨｽﾌﾟ小児用ﾈｰｻﾞﾙﾏｽｸ','wispPediatricNasalMask')">
                <img style="width: 140px; padding-left: 15px;" :src="require('@/assets/maskPng/list-wispNesalMask.png')" @click="setMaskType('ｳｨｽﾌﾟﾈｰｻﾞﾙﾏｽｸ','wispNesalMask')">
                <img style="width: 152px; padding-left: 15px; padding-right: 15px;" :src="require('@/assets/maskPng/list-picoNesalMask.png')" @click="setMaskType('ﾋﾟｺﾈｰｻﾞﾙﾏｽｸ','picoNesalMask')">
                <img style="width: 113px; padding-left: 10px;" :src="require('@/assets/maskPng/list-dreamWearSiliconePillowMask.png')" @click="setMaskType('ﾄﾞﾘｰﾑｳｪｱ ｼﾘｺﾝﾋﾟﾛｰﾏｽｸ','dreamWearSiliconePillowMask')">
                <img style="padding-left: 3px;" :src="require('@/assets/maskPng/list-dreamWearFull.png')" @click="setMaskType('ﾄﾞﾘｰﾑｳｪｱﾌﾙﾌｪｲｽﾏｽｸ','dreamWearFull')">
                <img :src="require('@/assets/maskPng/list-amaraViewFullFaceMask.png')" @click="setMaskType('ｱﾏﾗﾋﾞｭｰﾌﾙﾌｪｲｽﾏｽｸ','amaraViewFullFaceMask')">
                <img :src="require('@/assets/maskPng/list-amaraFullFaceMask.png')" @click="setMaskType('ｱﾏﾗﾌﾙﾌｪｲｽﾏｽｸ','amaraFullFaceMask')">
                <img :src="require('@/assets/maskPng/list-amaraGelFullFaceMask.png')" @click="setMaskType('ｱﾏﾗｼﾞｪﾙﾌﾙﾌｪｲｽﾏｽｸ','amaraGelFullFaceMask')">
                <img style="width: 128px; padding-left: 3px;" :src="require('@/assets/maskPng/list-fitLife.png')" @click="setMaskType('ﾌｨｯﾄﾗｲﾌ','fitLife')">
                <img style="width: 95px; padding-left: 3px;" :src="require('@/assets/maskPng/list-other.png')" @click="setMaskType('その他','other')">
              </div>
            </tr>
            <tr v-if="maskType" style="height:60px;">
              <td class="with-border" colspan="4" style="font-size:30px;">{{ maskType }}</td>
            </tr>
            <tr v-if="maskType && maskList[maskType].fileName">
              <td class="with-border" style="text-align: center; vertical-align: middle;">
                <img style="width:150px;height:150px;" :src="require('@/assets/maskPng/'+maskList[maskType].fileName+'.png')">
              </td>
              <td class="with-border" colspan="3" style="color:red;font-size:15px;width:700px;">
                <span v-if="isMagnet">※マグネティックヘッドギアクリップを用いて装着<br>マグネットの影響を受ける可能性がある機器が体に埋め込まれている患者およびそのような家族、介護者、ベッドパートナーが近くにいるような場合でのマスクの使用は禁じられています。<br>詳細は添付文書又は取扱説明書をご参照ください。</span>
              </td>
            </tr>
          </table>
        </div>
        <!-- 検索結果 -->
        <div class="result-area" v-if="maskType">
          <span class="annotation">★印は推奨セット</span>
          <b-table
            v-if="maskType"
            id="cpapMaskSelectTable"
            :data="displayData"
            paginated
            :per-page="pageSize"
            pagination-position="both"
            default-sort="id"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="id" label="" width="5" centered>
                <b-radio class="customRadio" name="radioItem" v-model="selectedItem" :native-value="props.row"></b-radio>
              </b-table-column>
              <b-table-column field="frequentlyUsed" label="マスク種類" width="100" centered sortable>
                <span v-if="props.row.frequentlyUsed">★</span>{{props.row.maskType }}<br>
              </b-table-column>
              <b-table-column field="cushionSize" label="クッションサイズ" width="60" centered sortable>{{props.row.cushionSize }}</b-table-column>
              <b-table-column field="frameSize" label="フレームサイズ" width="60" centered sortable>{{props.row.frameSize}}</b-table-column>
              <b-table-column field="fixingMethod" label="固定方法" width="100" centered sortable>{{props.row.fixingMethod}}</b-table-column>
            </template>
          </b-table>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="save" :disabled="!selectedItem">決定</button>
        <button class="button" type="button" @click="$parent.close()">閉じる</button>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  name: "CpapMaskSelectModal",
  props: {
    formatType:null
  },
  methods: {
    save: function() {
      this.$emit('select', this.selectedItem);
      this.$parent.close();
    },
    doSearch: function() {
      let _this = this;
      // Web Api Call
      this.apiCall(
        function(client){
          return client.apis.internalCpap.getCpapMaskListPOST({
            body:{
              formatType: _this.formatType
            }
          });
        },
        function(result) {
          // 検索結果取得
          _this.data = result.obj
          _this.displayData = _this.data
          _this.maskTypeList = _this.data.map(item => item.maskType)
          _this.maskTypeList = Array.from(new Set(_this.maskTypeList))
          _this.maskTypeList.sort(function (a, b) {
            return _this.maskList[a].sortNum - _this.maskList[b].sortNum
          });
        },
        function(result) {
          // エラーメッセージ表示
          _this.showErrorMessage(result);
        }
      );
    },
    setMaskType: function(name, fileName) {
      this.selectedItem = '';
      this.maskType = name
      this.fileName = fileName
      if(this.maskType && this.maskType != "その他"){
        this.displayData = this.data.filter(val => val.maskType==this.maskType)
        this.displayData.sort(function (a, b) {
          return a.displayOrder - b.displayOrder;
        });
        this.isMagnet = this.displayData[0].magnet
      } else if (this.maskType == "その他") {
        this.displayData = this.data.filter(val => val.maskType==this.maskType || val.maskType=="Vitera ﾌﾙﾌｪｲｽﾏｽｸ")
        this.displayData.sort(function (a, b) {
          return a.displayOrder - b.displayOrder;
        });
        this.isMagnet = false
      }else{
        this.isMagnet = false
      }
    }
  },
  data() {
    var maskList = {
      "ﾋﾟｺﾈｰｻﾞﾙﾏｽｸ":{sortNum:1, fileName:"picoNesalMask"},
      "ｳｨｽﾌﾟﾈｰｻﾞﾙﾏｽｸ":{sortNum:2, fileName:"wispNesalMask"},
      "ﾄﾞﾘｰﾑｳｪｱﾈｰｻﾞﾙﾏｽｸ":{sortNum:3, fileName:"dreamWearNasalMask"},
      "ﾄﾞﾘｰﾑｳｪｱ ｼﾘｺﾝﾋﾟﾛｰﾏｽｸ":{sortNum:4, fileName:"dreamWearSiliconePillowMask"},
      "ﾄﾞﾘｰﾑｳｪｱﾌﾙﾌｪｲｽﾏｽｸ":{sortNum:5, fileName:"dreamWearFull"},
      "ｱﾏﾗﾋﾞｭｰﾌﾙﾌｪｲｽﾏｽｸ":{sortNum:6, fileName:"amaraViewFullFaceMask"},
      "ｱﾏﾗﾌﾙﾌｪｲｽﾏｽｸ":{sortNum:7, fileName:"amaraFullFaceMask"},
      "ｱﾏﾗｼﾞｪﾙﾌﾙﾌｪｲｽﾏｽｸ":{sortNum:8, fileName:"amaraGelFullFaceMask"},
      "ｳｨｽﾌﾟ小児用ﾈｰｻﾞﾙﾏｽｸ":{sortNum:9, fileName:"wispPediatricNasalMask"},
      "ﾌｨｯﾄﾗｲﾌ":{sortNum:10, fileName:"fitLife"},
      "その他":{sortNum:11, fileName:"other"},
      "Vitera ﾌﾙﾌｪｲｽﾏｽｸ":{sortNum:12, fileName:null},
    }
    return {
      maskType:"",
      selectedItem:'',
      maskTypeList:[],
      data:[],
      displayData:[],
      maskList,
      isMagnet:false,
      pageSize:5
    };
  },
  filters: {},
  components: {},
  mounted: function () {
    this.doSearch()
  },
  watch: {
  }
};
</script>
<style lang="scss" scoped>
.customRadio {
  width:10px;
}
.annotation {
  float:left;
  margin-top:20px;
  margin-left:10px;
  font-size: 1.0em;
}
.modal-card-body {
  padding-bottom: 10px;
}
.image-box {
  display: flex;
  cursor: pointer;
  width: 1300px;
}
.image-box img {
  width: 97px;
  height: 211px;
}
.conditionTable td,
.conditionTable tr,
.conditionTable {
  border: none !important;
}
.conditionTable td.with-border {
  border: solid 1px darkgray !important;
}
table.conditionTable {
  width: 100% !important;
  table-layout: fixed;
}
table.conditionTable td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* マグネット注意文のセルだけ折り返す */
td.with-border span {
  white-space: normal;
  overflow-wrap: break-word;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/common/CpapMaskSelectModal.vue